import { CLEAR_ERRORS, GET_ERRORS, CLEAR_ERROR_ON_HANDLE_CHANGE, GET_CUSTOM_ERRORS } from './types'
import { notificationDangerCustomTime, notificationDangerMultipleRows } from '../utils/customToastify'

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  }
}

export const clearErrorOnHandleChange = (name) => (dispatch) => {
  return dispatch({
    type: CLEAR_ERROR_ON_HANDLE_CHANGE,
    payload: name,
  })
}

export const clearAllErrors = () => (dispatch) => {
  return dispatch({
    type: CLEAR_ERRORS,
  })
}

export const setCustomError = (name, value) => (dispatch) => {
  dispatch({
    type: GET_CUSTOM_ERRORS,
    payload: { [name]: value },
  })
}

export const handleErrors = (error) => (dispatch) => {
  dispatch(clearErrors())
  if (error.response.status === 400) {
    if (error.response.data.isImageValidation) {
      notificationDangerCustomTime(error.response.data.error)
      return
    }
    if (error.response.data.isCustom) {
      dispatch({
        type: GET_CUSTOM_ERRORS,
        payload: error.response.data.error,
      })
      return
    }

    if (!error.response.data.isImageValidation || !error.response.data.isCustom) {
      const errors = Object.entries(error.response.data.error)
      notificationDangerMultipleRows(errors)
      dispatch({
        type: GET_ERRORS,
        payload: error.response.data,
      })
      return
    }
  }
  if (error.response.status === 422) {
    notificationDangerCustomTime(error.response.data, 5000)
    return
  }
  notificationDangerCustomTime(error.message, 5000)
}
